<template>
  <div class="box">
    <div
      id="healthAdviceTop"
      ref="top"
      style="width: 0;height:0;"
    ></div>
    <div class="main">
      <div class="collapse-header">
        <div>
          <span class="line"></span>
          {{ data.shortTestTime }} {{ data.time }}
        </div>
      </div>
      <!-- （value1,value2,value3三个值按顺序 身高、体重、BMI；收缩压、舒张压、静息心率;空腹血糖、餐后血糖、随机血糖） -->
      <div
        class="content"
        v-if="type == 1"
      >
        <div>
          <span>{{ data.value1 }}</span>
          <span class="span">身高/cm</span>
        </div>
        <div>
          <span>{{ data.value2 }}</span>
          <span class="span">体重/kg</span>
        </div>
        <div>
          <span>{{ data.value3 }}</span>
          <span class="span">BMI</span>
        </div>
      </div>
      <div
        class="content"
        v-if="type == 2"
      >
        <div>
          <span>{{ data.value1 }}</span>
          <span class="span">收缩压mmHg</span>
        </div>
        <div>
          <span>{{ data.value2 }}</span>
          <span class="span">舒张压mmHg</span>
        </div>
        <div>
          <span>{{ data.value3 }}</span>
          <span class="span">心率/次/分钟</span>
        </div>
      </div>
      <div
        class="content"
        v-if="type == 3"
      >
        <div>
          <span>{{ data.value1 }}</span>
          <span class="span">体温℃</span>
        </div>
      </div>
      <div
        class="content"
        v-if="type == 5"
      >
        <div>
          <span>{{ data.value1 }}</span>
          <span class="span">心率（次/分）</span>
        </div>
      </div>
      <div
        class="content"
        v-if="type == 4"
      >
        <div v-if="data.physicalItemIdentifier == 'BG_002'">
          <span>{{ data.value1 }}</span>
          <span class="span">空腹/mmol/L</span>
        </div>
        <div v-if="data.physicalItemIdentifier == 'BG_001'">
          <span>{{ data.value1 }}</span>
          <span class="span">餐后/mmol/L</span>
        </div>
        <div v-if="data.physicalItemIdentifier == 'BG_003'">
          <span>{{ data.value1 }}</span>
          <span class="span">随机/mmol/L</span>
        </div>
      </div>
      <div
        class="content"
        v-if="type == 6"
      >
        <div style="display: flex; flex-direction: row;">
          <span>{{ data.value1 }}</span>
          <span class="span">%</span>
        </div>
        <div style="display: flex; flex-direction: row;">
          <span>{{ data.value2 }}</span>
          <span class="span">脉率/次/分</span>
        </div>
      </div>
      <div
        class="content bfContent"
        v-if="type == 7"
        style="padding: 0 10%;"
      >
        <div style="display: flex; flex-direction: column;">
          <div style="width: 100%; display: flex; flex-direction: row; margin: 10px;">
            <div class="bfFlex" style="margin-right: 10px;">
              <span>{{ data.value4 }}</span>
              <span class="span">总胆固醇/mmol/L</span>
            </div>
            <div class="bfFlex">
              <span>{{ data.value3 }}</span>
              <span class="span">甘油三酯/mmol/L</span>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; margin: 10px;">
            <div class="bfFlex" style="margin-right: 10px;">
              <span >{{ data.value1 }}</span>
              <span class="span">低密度脂蛋白/mmol/L</span>
            </div>
            <div class="bfFlex">
              <span>{{ data.value2 }}</span>
              <span class="span">高密度脂蛋白/mmol/L</span>
            </div>
          </div>
        </div>
      </div>
      <div class="border-top"></div>

      <div
        class="state"
        v-if="type == 1"
      >
        体质指数：
        <span
          :class="
            data.parameterStatus == 1
              ? 'redSpan'
              : data.parameterStatus == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName }}</span>
      </div>
      <div
        class="state"
        v-if="type == 2"
      >
        血压：
        <span
          :class="
            data.parameterStatus == 1
              ? 'redSpan'
              : data.parameterStatus == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName }}</span>
      </div>
      <div
        class="state"
        v-if="type == 3"
      >
        体温：
        <span
          :class="
            data.parameterStatus == 1
              ? 'redSpan'
              : data.parameterStatus == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName }}</span>
      </div>
      <div
        class="state"
        v-if="type == 4"
      >
        血糖：
        <span
          :class="
            data.parameterStatus == 1
              ? 'redSpan'
              : data.parameterStatus == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName }}</span>
      </div>
      <div
        class="state"
        v-if="type == 5"
      >
        心率指数：
        <span
          :class="
            data.parameterStatus == 1
              ? 'redSpan'
              : data.parameterStatus == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName }}</span>
      </div>
      <div
        class="state"
        v-if="type == 6"
        style="padding-bottom: 8px;"
      >
        血氧：
        <span
          :class="
            data.parameterStatus == 1
              ? 'redSpan'
              : data.parameterStatus == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName }}</span>
      </div>
      <div
        class="state"
        v-if="type == 6 && data.physicalItemParmName1"
        style="padding-top: 8px;"
      >
        脉率：
        <span
          :class="
            data.parameterStatus1 == 1
              ? 'redSpan'
              : data.parameterStatus1 == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName1 }}</span>
      </div>
      <div
        class="state"
        v-if="type == 7"
        style="padding-bottom: 8px;"
      >
        总胆固醇：
        <span
          :class="
            data.parameterStatus3 == 1
              ? 'redSpan'
              : data.parameterStatus3 == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName3 }}</span>
      </div>
      <div
        class="state"
        v-if="type == 7"
        style="padding-top: 8px;padding-bottom: 8px;"
      >
        甘油三酯：
        <span
          :class="
            data.parameterStatus2 == 1
              ? 'redSpan'
              : data.parameterStatus2 == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName2 }}</span>
      </div>
      <div
        class="state"
        v-if="type == 7"
        style="padding-top: 8px;padding-bottom: 8px;"
      >
        低密度脂蛋白：
        <span
          :class="
            data.parameterStatus == 1
              ? 'redSpan'
              : data.parameterStatus == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName }}</span>
      </div>
      <div
        class="state"
        v-if="type == 7"
        style="padding-top: 8px;"
      >
        高密度脂蛋白：
        <span
          :class="
            data.parameterStatus1 == 1
              ? 'redSpan'
              : data.parameterStatus1 == 3
              ? 'orangeSpan'
              : 'blueSpan'
          "
        >{{ data.physicalItemParmName1 }}</span>
      </div>
      <div
        class="advice"
        v-if="data.parameterStatus != 2"
      >
        <div
          class="top"
          v-if="data.drinkSuggest"
        >饮食建议：</div>
        <div
          class="bottom"
          v-if="data.drinkSuggest"
        >{{ data.drinkSuggest }}</div>
        <div
          class="top"
          v-if="data.sportSuggest"
        >运动建议：</div>
        <div
          class="bottom"
          v-if="data.sportSuggest"
        >{{ data.sportSuggest }}</div>
        <div
          class="top"
          v-if="data.healthSuggest"
        >养生建议：</div>
        <div
          class="bottom"
          v-if="data.healthSuggest"
        >{{ data.healthSuggest }}</div>
        <div
          class="top"
          v-if="data.knowledgeSuggest"
        >健康常识：</div>
        <div
          class="bottom"
          v-if="data.knowledgeSuggest"
        >{{ data.knowledgeSuggest }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'record',
    components: {},
    data() {
      return {
        type: 1,
        id: 0,
        data: {}
      }
    },
    beforeCreate() {
      document
        .querySelector('body')
        .setAttribute('style', 'background-color:#F8F8F8;')
    },
    created() {
      this.type = this.$route.query.type
      this.data = this.$route.query.data
    },
    mounted() {
      window.scrollTo(0, 0)
      // this.goTop()
    },
    methods: {
      // goTop() {
      //   this.$refs.top.scrollIntoView()
      // }
    }
  }
</script>

<style scoped lang="less">
  .box {
    padding: 16px 0;
  }
  .main {
    width: 718px;
    min-height: 200px;
    //   min-height: 900px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    margin: 0 auto;
    .collapse-header {
      height: 72px;
      line-height: 72px;
      text-align: left;
      font-size: 32px;
      font-weight: bold;
      color: #3e3e3e;
      border-bottom: 2px solid #d0d6e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        font-weight: bold;
      }
      .line {
        display: inline-block;
        width: 4px;
        height: 20px;
        background: #357dfa;
        margin-right: 12px;
        margin-left: 16px;
      }
    }
    .content {
      min-height: 160px;
      margin: 0 auto;
      padding: 0 128px;
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 40px;
        font-weight: bold;
        color: #3e3e3e;
        span:first-child {
          font-weight: bold;
        }
        .span {
          font-size: 24px;
          font-weight: 400;
          color: #868686;
          padding-top: 8px;
        }
      }
    }
    .border-top {
      width: 686px;
      margin: 0 auto;
      border-bottom: 2px solid #d0d6e6;
    }
    .state {
      font-size: 32px;
      font-weight: bold;
      color: #3e3e3e;
      padding: 48px 0px 32px 32px;
      .blueSpan {
        color: #357dfa;
        font-weight: bold;
      }
      .orangeSpan {
        color: #ffaf46;
        font-weight: bold;
      }
      .redSpan {
        color: #ff5266;
        font-weight: bold;
      }
    }
    .advice {
      font-size: 28px;
      font-weight: 400;
      color: #3e3e3e;
      padding: 0 32px;
      line-height: 48px;
      .top {
        font-weight: 600;
      }
      .bottom {
        text-indent: 64px;
        padding-bottom: 20px;
      }
    }
  }
</style>
